<template>
  <item-wrapper
    v-if="text !== null"
    class="text-prop"
    :show-tooltip="showTooltip"
    :tooltip="prop.label"
  >
    <div
      :class="['_text', wrap ? '-wrap' : '']"
    >
      {{ text }}
    </div>
  </item-wrapper>
</template>

<script>
import ItemWrapper from '@/components/list/ItemWrapper.vue';
import { getValueFromEntity } from '@/lib/props';
import { shortenText } from '@/lib/text';

export default {
  name: 'TextProp',
  props: {
    prop: {
      type: Object,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    propertyValuesKey: {
      type: String,
      default: 'properties',
    },
    maxTextLength: {
      type: Number,
      default: 40,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
  },
  components: { ItemWrapper },
  computed: {
    text() {
      const val = getValueFromEntity(this.prop, this.entity, this.propertyValuesKey);
      return shortenText(val, this.maxTextLength);
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .text-prop {
    display: flex;
    align-items: center;
    width: 100%;

    ._text {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.-wrap {
        white-space: normal;
      }
    }
  }
</style>
